import Badge from '@mui/material/Badge';
import { useOpenBetslipCount } from '../../queries';
import { StyleObj } from '../../@types';

const styles: StyleObj = {
  badge: {
    position: 'absolute',
    top: {
      xs: 10,
      md: 12,
    },
    right: 4,
    '& .MuiBadge-badge': {
      fontSize: {
        xs: 10,
        md: 12,
      },
      height: 16,
      minWidth: 16,
      px: 0.5,
      color: 'primary.700',
    },
  },
};

const MyBetsCountBadge = () => {
  const { data: myBetsCount } = useOpenBetslipCount();

  return <Badge badgeContent={myBetsCount} color='secondary' sx={styles.badge} />;
};

export default MyBetsCountBadge;
